import { createSessionLifecycle } from "../../platform/auth/createSessionLifecycle";
import { clearIdentitySession, readStoredUser } from "./authStorage";
import { verifyCampaignsIdentitySession } from "./identitySession";

const CHANNEL_NAME = "clikkle.campaigns.auth";
const AUTH_EVENT = "clikkle:campaigns-auth";
const UNAUTHORIZED_EVENT = "clikkle:campaigns-unauthorized";

const lifecycle = createSessionLifecycle({
  channelName: CHANNEL_NAME,
  unauthorizedEvent: UNAUTHORIZED_EVENT,
  verifySession: verifyCampaignsIdentitySession,
  hasLocalSession: () => Boolean(readStoredUser() && localStorage.getItem("refreshToken")),
  clearSession: clearIdentitySession,
});

export function broadcastCampaignsAuth(type, detail = {}) {
  const message = lifecycle.publish(type, detail);
  window.dispatchEvent(new CustomEvent(AUTH_EVENT, { detail: message }));
}

export function notifyCampaignsUnauthorized(detail = {}) {
  window.dispatchEvent(new CustomEvent(UNAUTHORIZED_EVENT, { detail }));
}

export function revalidateCampaignsSession({ force = false } = {}) {
  return lifecycle.revalidate({ force });
}

export function installCampaignsSessionLifecycle(callbacks = {}) {
  return lifecycle.install(callbacks);
}
